import { useEffect, useState } from "react";
import { getTemplateById, getTemplatesList } from "./Api";
import "./Templates.scss";

function TemplatesList(props) {
	const templates = useTemplates();
	return (
		<div className='templates-list'>
			{templates.map((item) => {
				return (
					<button
						onClick={() => {
							props.setCurrentTemplateInfo({
								id: item.ID,
								name: item.PATT_NAME,
							});
							props.setTemplateWindowOpen(true);
						}}
					>
						{item.PATT_NAME}
					</button>
				);
			})}
		</div>
	);
}

const useTemplates = () => {
	const [templates, setTemplates] = useState([]);
	useEffect(() => {
		getTemplatesList().then((res) => setTemplates(res));
	}, []);
	return templates;
};

export default TemplatesList;
